import { useTranslate } from '@tolgee/react';
import { Button, Popover, Tooltip } from 'antd';
import { useIsChatttUpdate, useIsFettUpdate, useSetUpdaterVisible } from 'hooks/useUpdater';
import { ReactComponent as SettingIcon } from './assets/setting.svg';
import { StyledBadge, Trigger } from './style';
import { InfoCircleFilled } from '@ant-design/icons';
import { useBoolean, useMemoizedFn } from 'ahooks';
import { useEffect, useMemo } from 'react';
import { eventBus } from 'services/eventBus';

export const MoreSettings = () => {
  const { t } = useTranslate();

  const [popVisible, { setTrue: showPop, setFalse: hidePop }] = useBoolean(false);
  const isChatttUpdate = useIsChatttUpdate();
  const isFettUpdate = useIsFettUpdate();
  const setUpdateVisible = useSetUpdaterVisible();

  const hasClientUpdate = useMemo(
    () => isChatttUpdate.value || isFettUpdate.value,
    [isChatttUpdate, isFettUpdate],
  );

  const openModal = useMemoizedFn(() => {
    hidePop();
    eventBus.emit('SHOW_SYSTEM_MODAL', {
      activeKey: 'preference',
    });
  });

  useEffect(() => {
    if (hasClientUpdate) {
      showPop();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [hasClientUpdate]);

  const content = (
    <div className="flex flex-col gap-2">
      <div className="flex items-center gap-2">
        <InfoCircleFilled className="!text-primary" />
        <span>{t('发现新版本')}</span>
      </div>
      <div className="flex items-center justify-end gap-2">
        <Button className="!text-xs" size="small" onClick={hidePop}>
          {t('ViewSystem.system.on.quit.close')}
        </Button>
        <Button
          className="!text-xs"
          size="small"
          type="primary"
          onClick={() => {
            hidePop();
            if (hasClientUpdate) {
              setUpdateVisible(true);
            }
          }}
        >
          {t('立即更新')}
        </Button>
      </div>
    </div>
  );

  return (
    <Popover content={content} placement="rightBottom" visible={popVisible}>
      <Tooltip title={t('nav.设置')} placement="right">
        <Trigger onClick={openModal} data-guide="nav-guide-step-4">
          <StyledBadge dot={hasClientUpdate}>
            <SettingIcon />
          </StyledBadge>
        </Trigger>
      </Tooltip>
    </Popover>
  );
};
